import React, { FC, useState } from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import FormLabel, { FormLabelProps } from "@mui/material/FormLabel";
import { useTheme } from "@mui/material/styles";

import BottomSheet, { BottomSheetData } from "@/components/molecules/BottomSheet/BottomSheet";
import { StyledBottomSheetButton } from "@/styles/styled";

import Tooltip from "../../Tooltip/Tooltip";

export interface InputLabelProps extends FormLabelProps {
    text: string;
    tooltip?: string;
    tooltipTitle?: string;
    bottomSheetMode?: boolean;
    className?: string;
}

const InputLabel: FC<InputLabelProps> = ({
    text,
    tooltip,
    tooltipTitle,
    className,
    bottomSheetMode = false,
    ...rest
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [bottomSheetData, setBottomSheetData] = useState<BottomSheetData>(null);

    return (
        <>
            <FormLabel className={clsx("label", className)} {...rest}>
                {t(text)}
                {tooltip && !bottomSheetMode && !isMobileScreen && (
                    <>
                        {" "}
                        <Tooltip label={tooltip} />
                    </>
                )}
                {tooltip && (bottomSheetMode || isMobileScreen) && (
                    <>
                        {" "}
                        <StyledBottomSheetButton
                            $hideDesktop={!bottomSheetMode}
                            $inline
                            onClick={(e) => {
                                e.preventDefault();
                                setBottomSheetData({ title: tooltipTitle || text, content: tooltip });
                            }}
                        >
                            {t("Common.MoreInformations")}
                        </StyledBottomSheetButton>
                    </>
                )}
            </FormLabel>
            {bottomSheetData && (
                <BottomSheet
                    title={bottomSheetData.title}
                    content={bottomSheetData.content}
                    handleOverlayClick={() => setBottomSheetData(null)}
                />
            )}
        </>
    );
};

export default InputLabel;
